<template>
  <FormCheckboxes v-if="isMultiSelect"
                  :name="`checkboxes-${customNameSuffix || randomId}`"
                  :options="formattedOptions"
                  :model-value="selectedOption || []"
                  items-center
                  :custom-accent-hex="darkestHexValue"
                  checkbox-container-classes="gap-2.5 -ml-0.5"
                  checkbox-size="h-5 w-5 rounded"
                  text-class="text-base font-normal text-slate-900"
                  mb-class="mb-2"
                  @update:modelValue="updateAnswer"
  />
  <FormRadios v-else
              :name="`radios-${customNameSuffix || randomId}`"
              :model-value="selectedOption"
              :options="formattedOptions"
              :custom-accent-hex="darkestHexValue"
              class="mt-1"
              mb-class="mb-2"
              text-class="text-base font-normal text-slate-900 gap-3"
              @update:modelValue="updateAnswer"
  />
</template>

<script setup>
import {computed, inject, ref, watch} from "vue";
import FormRadios from "./FormRadios.vue";
import {darkestHex} from "../helpers/Color";
import FormCheckboxes from "./FormCheckboxes.vue";

const emits = defineEmits(["update:answer"]);
const props = defineProps({
  question: Object,
  answer: Object,
  isMultiSelect: Boolean,
  customNameSuffix: [String, Number],
});

const randomId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

const typeformData = inject("typeformData", {});
const darkestHexValue = computed(() => darkestHex(typeformData.primaryBackground, typeformData.primaryForeground));

const selectedOption = ref(props.answer?.answer || null);

const formattedOptions = computed(() => {
  return props.question.options.map(option => option.value);
});

const updateAnswer = (value) => {
  emits("update:answer", {value});
  selectedOption.value = value;
};

watch(() => props.answer, () => {
  selectedOption.value = props.answer?.answer || null;
});
</script>
